import { render, staticRenderFns } from "./SpotsContentItems.vue?vue&type=template&id=46b30f58&"
import script from "./SpotsContentItems.vue?vue&type=script&lang=js&"
export * from "./SpotsContentItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports